const animal = {
    ru: {
        cattle: {
            filter: {
                building: "здание",
                animal: "Фильтр животное"
            },
            form: {
                title: {
                    editAnimal: "Изменить животное №",
                    newAnimal: "Новое животное",
                    moveAnimal: "переместить животное"
                },
                field: {
                    building: "Здание",
                    buckleNumber: "№ бирки",
                    birthday: "Дата рождения",
                    type: "Тип животного",
                    mother: "Мать",
                    father: "Отец",
                    isBought: "Купленный живот",
                    newSickness: "Обнаружено новое заболевание",
                    currentSickness: "Текущее заболевание",
                    onGoing: "продолжающий",
                    terminated: "прекращена"

                },
                placeholder: {
                    selectFather: "Выбрать отца",
                    selectMother: "Выбрать матери"
                }
            },
            dialog: {
                message: "Удалить животное {buckle} ?"
            }
        },
        insemination: {
            tooltip: {
                toInseminate: "Осеменать",
                toCalve: "Новый отёль",
                toDryUp: "Новый запуск",
                toUltrasound: "УЗИ",
                seenHot: "В охоте",
                toCull: "Брак",
                toSeeHistory: "Посмотреть резюме"
            },
            filter: {
                states: "Фильтр группы",
                culled: "Фильтр Брак"

            },
            form: {
                title: {
                    editInsemination: "Изменить осеменение",
                    newInsemination: "Осемение для №",
                    newCalving: "Новый отель для №",
                    newUltrasound: "Новый УЗИ для №",
                    setCulled: "Брак №",
                    setDried: "Проводить в запуске №",
                    setInHeat: "Видно в охоте"
                },
                field: {
                    fromSemen: "И.О.",
                    fromBull: "Случка с быком",
                    artificialFatherName: "Наименование Быка",
                    calvingDate: "Дата отёла",
                    ultrasoundDate: "Дата УЗИ",
                    inseminationDate: "Дата осеменения",
                    cullDate: "Дата брак",
                    inheatDate: "Дата видно в охоте",
                    dryupDate: "Дата запуск",
                    price: "Цена продажи"
                }
            }
        },
        card: {
            history: "Резюме",
            summary: "Резюме",
            ascendance: "родословная",
            'insemination-productivity': "Осеменение и продуктивность",
            birthday: "Дата рождения : ",
            fecondity: "Статус : ",
            lactation: "Количество лактации : ",
            milk: "Молоко",
            motherAndFather: 'Мать | Отец',
            byArtificialFather: "По семени",
            byBull: "Быком",
            father: "Отец :",
            mother: "Мать :"
        },
        milk: {
            title: {
                uploadExcel: "Запись контрольную лойку"
            },
            list: {
                inspection: "Контрольная дойка"
            },
            form: {
                date: "Дата контрольную дойку",
                firstMilking: "1ая дойка",
                secondMilking: "2ая дойка",
                thirdMilking: "3ая дойка",
                total: "Сумма",
                downloadModel: "Скачать модель"
            },
            dialog: {
                message: "Удалить контроль из {date} ?"
            }
        }
    },
    fr: {
        cattle: {
            filter: {
                building: "Bâtiments",
                animal: "Filtres animal"
            },
            form: {
                title: {
                    editAnimal: "Modifier animal n°",
                    newAnimal: "Nouvel animal",
                    moveAnimal: "Déplacer l'animal"
                },
                field: {
                    building: "Bâtiment",
                    buckleNumber: "Numéro de boucle",
                    birthday: "Jour de naissance",
                    type: "Type d'animal",
                    mother: "Mère",
                    father: "Père",
                    isBought: "Animal acheté",
                    newSickness: "Nouvelle maladie détectée",
                    currentSickness: "Maladie(s) actuelle(s)",
                    onGoing: "en cours",
                    terminated: "terminé"
                },
                placeholder: {
                    selectFather: "Sélectionner le père",
                    selectMother: "Sélectionner la mère"
                }
            },
            dialog: {
                message: "Supprimer l\'animal {buckle} ?"
            }
        },
        insemination: {
            tooltip: {
                toInseminate: "Inséminer",
                toCalve: "Vêler",
                toDryUp: "Tarir",
                toUltrasound: "échographier",
                seenHot: "Vue en chaleur",
                toCull: "Réformer",
                toSeeHistory: "Voir l'historique"
            },
            filter: {
                states: "Filtres état",
                culled: "Filtres réformé"
            },
            form: {
                title: {
                    newInsemination: "Insémination de",
                    newCalving: "Nouveau vélage pour n°",
                    newUltrasound: "Nouvel ultrason",
                    setCulled: "Réformer n°",
                    setDried: "Mettre à tarir",
                    setInHeat: "Déclarer une chaleur"
                },
                field: {
                    fromSemen: "Semence achetée",
                    fromBull: "Insémination par taureau",
                    artificialFatherName: "Nom du taureau",
                    father: "Inséminé par",
                    calvingDate: "Date du vêlage",
                    ultrasoundDate: "Date de l'ultrason",
                    inseminationDate: "Date d'insémination",
                    cullDate: "Date de mise en réforme",
                    inheatDate: "Date de vue en chaleur",
                    dryupDate: "Date du tarissement",
                    price: "Prix de vente"
                }
            }
        },
        card: {
            history: "Historique",
            summary: "Résumé",
            ascendance: "Ascendance",
            'insemination-productivity': "Insémination et productivité",
            birthday: "Date de naissance : ",
            fecondity: "Etat de fécondité : ",
            lactation: "Nombre de lactation : ",
            milk: "Courbe de lait",
            motherAndFather: 'Mère et Père',
            byArtificialFather: "Par semence",
            byBull: "Par taureau",
            father: "Père :",
            mother: "Mère :"
        },
        milk: {
            title: {
                uploadExcel: "Envoyer résultats du contrôle"
            },
            list: {
                inspection: "Contrôle laitier"
            },
            form: {
                date: "Date du contrôle laitier :",
                firstMilking: "1ère traite",
                secondMilking: "2ème traite",
                thirdMilking: "3ème traite",
                total: "total (en L)",
                downloadModel: "Télécharger le modèle"
            },
            dialog: {
                message: "Supprimer le contrôle laitier du {date} ?"
            }
        }
    }
}

export default animal